import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { Breadcrumb } from '../../../../components/Breadcrumb';
import { PageHeader } from '../../../../components/PageHeader';
import { createSupplier } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { CreateSupplierForm } from '../../components/CreateSupplierForm';
import { PageHeading } from 'components/PageHeading';
import { captureException } from '@sentry/react';
import { trackEvent } from '../../../../utils/track-event';

const CreateSupplierPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title="Nieuwe vervoerder" />

      <PageHeading
        leftSide={
          <Breadcrumb
            parentItem={{
              name: 'Vervoerders',
              to: '/internal/suppliers',
            }}
            currentItem={'Nieuwe vervoerder'}
          />
        }
      />

      <div className="px-4">
        <CreateSupplierForm
          onSubmit={async (inputData) => {
            try {
              const result = await createSupplier(inputData);
              trackEvent('supplier_created', {
                supplier_id: result.id,
                country: inputData.country,
              });
              navigate(`../${result.id}/general`, { replace: true });
              toast.success('Vervoerder aangemaakt');
            } catch (err: any) {
              captureException(err);
              toast.error('Kon vervoerder niet aanmaken: ' + getDisplayError(err));
            }
          }}
        />
      </div>
    </>
  );
};

export default CreateSupplierPage;
